import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { setInputRows } from '../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../components/procedure/store/procedure.types'
import { getIntubationSelector } from '../selectors'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'
import { IOptions } from '../../../common/common.types'

export interface IAirwayComplicationAction {
  type: string
  airwayComplications: IOptions | []
}

export function* setAirwayComplications(action: IAirwayComplicationAction) {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const intubationState: IIntubationState = yield select(getIntubationSelector)
  const { inputRows } = procedureState
  const { airwayComplicationsPNNV } = intubationState

  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === IntubationConstants.SET_AIRWAY_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = action.airwayComplications
        //@ts-ignore
        input.props.savedPNNVValue = airwayComplicationsPNNV
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setAirwayComplicationsSaga() {
  yield takeLatest([IntubationConstants.SET_AIRWAY_COMPLICATIONS], setAirwayComplications)
}
